import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button/Button';
import { DialogBody, DialogFooter } from '@/components/ui/Dialog/Dialog';
import { Illustration } from '@/components/ui/Illustration/Illustration';

interface SchedulingPausedStepProps {
  onClose: () => void;
}

// Shown in place of any scheduling, rescheduling or cancelling step while scheduling is blocked for maintenance,
// including in dialogs that were already open when the block started.
export const SchedulingPausedStep = ({ onClose }: SchedulingPausedStepProps) => {
  const { t } = useTranslation('scheduling', { keyPrefix: 'schedulingPaused.step' });

  return (
    <>
      <DialogBody>
        <div className='-mt-16 flex flex-1 flex-col items-center justify-center text-center'>
          <Illustration name='skater' className='m-3 w-[127px]' />
          <h3 className='text-heading-m-semibold mt-6 mb-4 w-[320px] max-w-full'>{t('title')}</h3>
          <p className='text-text-default-secondary w-[320px] max-w-full'>{t('description')}</p>
        </div>
      </DialogBody>
      <DialogFooter className='shrink-0 flex-col! gap-3 p-6'>
        <Button onClick={onClose} className='w-full'>
          {t('closeButton.label')}
        </Button>
      </DialogFooter>
    </>
  );
};
